import React from 'react';
import { Field } from 'redux-form';
import { PropTypes } from 'prop-types';
import { required } from 'redux-form-validators';

import { STATIC_ROOT } from '../../constants';

import {
    FormInputContainerComponent,
    ItemComponent,
    InputComponent
} from './InputWrappersComponent';
import SvgComponent from '../SvgComponent';
import Tooltip from '../tooltip/Tooltip';

/**
 * Wrap the InputComponent in a html structure
 * This component is passed to a Redux Form Field
 * @param {Component} InputComponent  input component
 * @param {object} input see Redux form Props doc
 * @param {object} meta see Redux form Props doc
 */
export class FieldComponent extends React.Component {
    renderErrorMessage(meta, input) {
        return (
            meta.touched &&
            meta.error && (
                <p className="input-error color-err" id={`error-${input.name}-${meta.form}`}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/picto-errors.svg`}
                        width={20}
                        height={20}
                        aria-hidden="true"
                        focusable="false"
                    />
                    {meta.error}
                </p>
            )
        );
    }

    render() {
        const {
            input,
            meta,
            label,
            placeholder,
            hideErrorMessage,
            classNameInputContainer,
            showSymbol,
            formName,
            hideLabel,
            tooltip,
            tooltipLabel
        } = this.props;

        const tooltipId = `tooltip-${input.name}-${formName}`;

        return (
            <FormInputContainerComponent
                className={`${classNameInputContainer ? classNameInputContainer : ''}${
                    hideLabel ? ' hidden-label' : ''
                }`}>
                <label
                    htmlFor={`${input.name}-${formName}`}
                    className={`label ${hideLabel ? 'sr-only' : ''}`}>
                    {label}
                </label>
                <ItemComponent className={`item ${tooltip ? 'with-tooltip' : ''}`}>
                    <InputComponent
                        {...this.props}
                        ref="inputRef"
                        placeholder={placeholder ? placeholder : label}
                    />
                    {showSymbol && <span>{showSymbol}</span>}
                    {tooltip && (
                        <Tooltip id={tooltipId} text={tooltip}>
                            <SvgComponent
                                src={`${STATIC_ROOT}/info.svg`}
                                height="16"
                                className="information-badge"
                                aria-hidden="true"
                                focusable="false"
                            />
                            <span className="sr-only">{tooltipLabel}</span>
                        </Tooltip>
                    )}
                </ItemComponent>
                {!hideErrorMessage && this.renderErrorMessage(meta, input)}
            </FormInputContainerComponent>
        );
    }
}

class InputFieldComponent extends React.Component {
    validateDefault = () => {
        if (this.props.isRequired) {
            return [
                required({
                    msg: this.props.i18nFeatureForm.REQUIRED,
                    allowBlank: !this.props.isRequired
                })
            ];
        }
        return [];
    };

    render() {
        const {
            isRequired,
            validate = [],
            label,
            additionalLabel,
            placeholder,
            hideRequired
        } = this.props;

        const isStringLabel = typeof label === 'string';
        const finalLabel = isStringLabel
            ? `${label || ''}${label && isRequired && !hideRequired ? '*' : ''}${additionalLabel || ''}`
            : (
                <React.Fragment>
                    {label}
                    {label && isRequired && !hideRequired ? '*' : ''}
                    {additionalLabel || ''}
                </React.Fragment>
            );

        return (
            <Field
                {...this.props}
                label={finalLabel}
                placeholder={`${placeholder ? placeholder : ''}${
                    placeholder && isRequired && !hideRequired ? '*' : ''
                }`}
                validate={[...this.validateDefault(), ...validate]}
                component={FieldComponent}
            />
        );
    }
}
/**
 * className :  additionnal css class to input element (node .input)
 */
InputFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['email', 'text', 'date', 'password', 'number', 'tel']).isRequired,
    label: PropTypes.string,
    additionalLabel: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    autoComplete: PropTypes.string,
    validate: PropTypes.array,
    warn: PropTypes.func,
    isRequired: PropTypes.bool,
    hideRequired: PropTypes.bool,
    hideLabel: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipLabel: PropTypes.string,
    hideErrorMessage: PropTypes.bool,
    classNameInputContainer: PropTypes.string,
    i18nFeatureForm: PropTypes.object.isRequired,
    showSymbol: PropTypes.string
};

export default InputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/InputFieldComponent.js